<template>
  <div class="seo-page">
    <LandingNavbar />
    <main class="seo-main">
      <header class="seo-hero">
        <p class="seo-kicker">KokeManga Guide</p>
        <h1>{{ $t('seoPage.guide.h1') }}</h1>
        <p class="seo-lead">{{ $t('seoPage.guide.lead') }}</p>
      </header>

      <article class="guide-article">
        <section v-for="(section, i) in sections" :key="i" class="guide-section">
          <h2>{{ section.title }}</h2>
          <p v-for="(p, j) in section.paragraphs" :key="j">{{ p }}</p>
          <ul v-if="section.list && section.list.length">
            <li v-for="(item, k) in section.list" :key="k">{{ item }}</li>
          </ul>
        </section>
      </article>

      <section class="seo-cta">
        <h2>{{ $t('seoPage.guide.ctaTitle') }}</h2>
        <p>{{ $t('seoPage.guide.ctaDesc') }}</p>
        <button class="btn-primary" @click="goTranslate">{{ $t('nav.startBtn') }}</button>
      </section>
    </main>
    <footer class="seo-footer">
      <router-link :to="localPath('/')">{{ $t('nav.home') }}</router-link>
      <router-link :to="localPath('/faq')">{{ $t('seoPage.faq.h1') }}</router-link>
      <router-link :to="localPath('/privacy')">{{ $t('manga.footer.privacy') }}</router-link>
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { localPath } from '@/i18n'
import LandingNavbar from '@/views/LandingNavbar.vue'

const router = useRouter()
const { t, tm } = useI18n()

const sections = computed(() => {
  const items = tm('seoPage.guide.sections')
  return Array.isArray(items) ? items : []
})

const goTranslate = () => {
  router.push(localPath('/MangaTranslation'))
}
</script>

<style scoped>
.seo-page {
  min-height: 100vh;
  background: #0b1020;
  color: #e8eefc;
}
.seo-main {
  max-width: 820px;
  margin: 0 auto;
  padding: 120px 20px 80px;
}
.seo-kicker {
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #7aa2ff;
  font-size: 13px;
  margin: 0 0 12px;
}
.seo-hero h1 {
  font-size: clamp(28px, 4vw, 40px);
  line-height: 1.25;
  margin: 0 0 16px;
}
.seo-lead {
  font-size: 18px;
  line-height: 1.75;
  color: #b7c3df;
  margin: 0;
}
.guide-section {
  margin-top: 36px;
}
.guide-section h2 {
  font-size: 24px;
  margin: 0 0 12px;
}
.guide-section p,
.guide-section li {
  line-height: 1.8;
  color: #c9d4ea;
}
.seo-cta {
  margin-top: 48px;
  padding: 28px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(86, 120, 255, 0.18), rgba(120, 80, 255, 0.12));
  border: 1px solid rgba(122, 162, 255, 0.25);
}
.btn-primary {
  margin-top: 12px;
  border: 0;
  border-radius: 999px;
  padding: 12px 22px;
  background: #4f7cff;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.seo-footer {
  max-width: 820px;
  margin: 0 auto;
  padding: 24px 20px 48px;
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
}
.seo-footer a {
  color: #8eb0ff;
  text-decoration: none;
}
</style>
